<template>
	<div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
		<Navigator :select-index="2" />
		<SliderBanner :data="slider" />

		<div class="container">

			<div class="page">
				<div>
					<h1 class="title">互动直播“场” 社交电商<span style="color: #ff4242;">必争之地</span></h1>
					<span class="desc">直播卖货到直播效果分析，智莺直播想你所想</span>
				</div>
				<div class="row justify-center" style="width: 100%;">
					<div class="col-md-4 col-xl-4 cnt">
						<div v-for="(item, idx) in swiper1" :key="'swiper1_'+idx"
							:class="swiper1Index === idx ? 'desc-card' : 'title-card'"
							@mouseover="handleSwiperIndex1(idx)">
							<h2 class="title">{{item.title}}</h2>
							<div v-if="swiper1Index === idx " class="tag">{{item.desc}}</div>
						</div>
						<el-button type="danger" style="margin-top: 20px;margin-left: 8px;" @click="handleLogin">
							开启你专属的直播间</el-button>
					</div>
					<div class="col-md-4 col-xl-4">
						<el-carousel ref="swiper1" indicator-position="none" arrow="never" :autoplay="false"
							style="height: 500px;">
							<el-carousel-item v-for="(item, idx) in swiper1" :key="'swiper_img1_'+idx">
								<img draggable="false" :src="item.image" alt="" />
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
			</div>
		</div>

		<div class="page page-bg" style="margin-bottom: 80px;padding-top: 120px;padding-bottom: 120px;">
			<div>
				<h1 class="title">全网唯一支持高级美颜直播</h1>
				<span class="desc">可轻松实现多种业务场景下客户的实时美颜需求</span>
			</div>
			<div class="row justify-center" style="width: 100%;margin-top: 40px;">
				<div class="col-md-3 col-xl-3 cnt">

					<h2 class="text" style="font-weight: normal;">全网唯一支持高级美颜直播（美白，磨皮，瘦脸，瘦身等上百种自定义美颜，数十种动态贴纸，上百种动态礼物等）
					</h2>
					<el-button type="danger" style="margin-top: 20px;margin-left: 8px;" @click="handleLogin">开启你专属的直播间
					</el-button>
				</div>
				<div class="col-md-3 col-xl-3" style="display: flex;justify-content: center;align-items: center;">
					<img draggable="false" :src="require('@/assets/images/live-video/2.png')" alt="" />
				</div>
			</div>
		</div>
		<div class="container">

			<div class="page page-bg1">
				<div>
					<h1 class="title">满足直播、短视频等多种<span style="color: #ff4242;">导购场景</span></h1>
					<span class="desc">直播卖货到直播效果分析，智莺直播想你所想</span>
				</div>
				<div class="row justify-center" style="width: 100%;">
					<div class="col-md-4 col-xl-4 cnt">
						<el-radio-group v-model="tabIndex"  size="small" @change="handleSwiper2Index(idx)">
							<el-radio-button v-for="(item, idx) in swiper2" :key="'swiper_button2_'+idx" :label="idx">
								{{item.title}}
							</el-radio-button>
						</el-radio-group>
					</div>
					<div class="col-md-4 col-xl-4"
						style="display: flex;justify-content: center;align-items: center;">
					</div>
				</div>
				<el-carousel ref="swiper2" indicator-position="none" arrow="never" :autoplay="false"
					style="height: 600px;width: 100%;">
					<el-carousel-item v-for="(item, idx) in swiper2" :key="'swiper_img2_'+idx">
						<div class="row justify-center" style="width: 100%;">
							<div class="col-md-4 col-xl-4 cnt">
								<h2 class="title-text">{{item.title}}</h2>
								<div class="text" style="margin-top: 14px;">{{item.desc}}</div>

								<el-button type="danger" style="margin-top: 20px;margin-left: 8px;"
									@click="handleLogin">
									开启你专属的直播间</el-button>
							</div>
							<div class="col-md-4 col-xl-4"
								style="display: flex;justify-content: center;align-items: center;">
								<img draggable="false" :src="item.image" alt="" />
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>

			</div>
		</div>

		<div class="page page-bg2">

			<div class="container" style="padding-bottom: 120px;">
				<div style="margin-top: 10vw;margin-bottom: 40px;">
					<h1 class="title">智莺直播电商<span style="color: #ff4242;">超强能力库</span></h1>
				</div>
				<div class="row justify-center" style="width: 100%;">
					<div class="col-md-4 col-xl-4 icon" v-for="(icon, idx) in icons" :key="idx">
						<img class="image" draggable="false" :src="icon.icon" alt="" />
						<span>{{icon.title}}</span>
						<span>{{icon.desc}}</span>
					</div>
				</div>

				<el-button type="danger" style="margin-top: 20px;margin-left: 8px;" @click="handleLogin">开启你专属的直播间
				</el-button>

			</div>
		</div>

		<Ad :data="ad" />

		<Contact />
		<Footer />
	</div>
</template>

<script>
	import Navigator from '../index/widgets/navigator.vue'
	import Contact from "../index/widgets/Contact.vue"
	import Footer from '../index/widgets/footer.vue'

	import SliderBanner from "../local/widgets/SliderBanner.vue"
	import Ad from "../local/widgets/Ad.vue"
	export default {
		components: {
			Navigator,
			SliderBanner,
			Contact,
			Footer,
			Ad
		},
		data() {
			return {
				swiper1Index: 0,
				tabIndex: 0,
				slider: {
					image: require('@/assets/images/live-video/phone.png'),
					title: '直播短视频',
					desc: "边播边卖、沉浸式购物，流量高效变现"
				},
				ad: {
					image: require('@/assets/images/live-video/ad.png'),
					title: '直播短视频',
					desc: "边播边卖、沉浸式购物，流量高效变现"
				},
				swiper1: [{
						image: require('@/assets/images/live-video/swiper1_1.png'),
						title: '边播边卖，导购在线推荐',
						desc: "导购/主播在线演示增强体验感和温度感，OMG式销货，狂增转化"
					},
					{
						image: require('@/assets/images/live-video/swiper1_2.png'),
						title: '一键下单，加速购买决策',
						desc: "内嵌商城无需跳转，直达购物场景，避免客户流失"
					},
					{
						image: require('@/assets/images/live-video/swiper1_3.png'),
						title: '多维数据统计，量化直播效果',
						desc: "直播数据指导实时互动；卖货数据优化选品方案"
					}
				],
				swiper2: [{
						image: require('@/assets/images/live-video/swiper2_1.png'),
						title: '直播导购',
						desc: "借助直播先天优势，通过在线互动、实物演示、实时答疑，增强顾客信任，加速购买决策。用智莺打通直播平台，轻松实现边播边卖，提升购买转化。"
					},
					{
						image: require('@/assets/images/live-video/swiper2_2.png'),
						title: '短视频导购',
						desc: "对接主流短视频平台，用短视频推荐商品，引导观众边看边买。商品、订单、资金手机端统一管理，省时省心。"
					}
				],
				icons: [{
						icon: require('@/assets/images/live-video/icon1.png'),
						title: '连接数十亿流量',
						desc: '更多平台更多订单',
					},
					{
						icon: require('@/assets/images/live-video/icon2.png'),
						title: '购买无需跳转',
						desc: '加速意向成单',
					},
					{
						icon: require('@/assets/images/live-video/icon3.png'),
						title: '多种直播间互动玩法',
						desc: '人气、粉丝尽收囊中',
					},
					{
						icon: require('@/assets/images/live-video/icon4.png'),
						title: '高清回放保存',
						desc: '全面直播复盘',
					},
					{
						icon: require('@/assets/images/live-video/icon5.png'),
						title: '清晰数据播报',
						desc: '业绩订单一目了然',
					},
					{
						icon: require('@/assets/images/live-video/icon6.png'),
						title: '多样化页面需求',
						desc: '满足个性化需求',
					}
				]
			}
		},
		methods: {
			handleLogin() {
				this.$router.push("/login");
			},
			handleSwiperIndex1(idx) {
				this.swiper1Index = idx
				this.$refs.swiper1.setActiveItem(idx)
			},
			handleSwiper2Index() {
				console.log(this.tabIndex)
				this.$refs.swiper2.setActiveItem(this.tabIndex)
			}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 767px) {
		.bg {
			background-size: auto 500px;
			background-repeat: no-repeat;
		}
	}

	@media (min-width: 767px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;
		}
	}

	@media (min-width: 992px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;
		}
	}

	.bg {
		background-image: url(../../assets/images/local/bg.png);
		// background-size: 100% 500px;

	}

	.page-bg {
		background-image: url(../../assets/images/live-video/bg.png);
		background-size: 100% auto;

	}

	.page-bg1 {
		background-image: url(../../assets/images/live-video/bg1.png);
		background-size: 100% auto;
	}

	.page-bg2 {
		background-image: url(../../assets/images/live-video/bg2.png);
		background-size: 100% auto;
	}


	.page {
		min-height: 60vh;
		display: flex;
		flex-direction: column;
		// justify-content: center;
		align-items: center;
		text-align: center;

		.cnt {
			margin-top: 40px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
		}

		.title {
			font-size: calc(1em + 1vw);
			color: #333333;
			font-weight: 600;
		}

		.desc {
			font-size: calc(0.5em + 0.5vw);
			color: #666666;
		}

		.title-card {
			width: 100%;
			border-radius: 5px;
			padding: 12px;
			text-align: start;
			margin-right: 10px;
			margin-bottom: 10px;

			.title {
				font-size: calc(0.5em + 0.5vw);
				line-height: calc(0.8em + 0.8vw);
				color: #333333;
				font-weight: 600;
			}

			.desc {
				display: none;
			}
		}

		.desc-card {
			width: 100%;
			background: #FFF7F2;
			border-radius: 5px;
			padding: 12px;
			text-align: start;
			margin-right: 10px;
			margin-bottom: 10px;

			.title {
				font-size: calc(0.5em + 0.5vw);
				line-height: calc(0.8em + 0.8vw);
				color: #333333;
				font-weight: 600;
			}

			.desc {
				font-size: calc(0.4em + 0.4vw);
				color: #666666;
			}

		}

		.item {
			text-align: start;
			font-size: calc(0.5em + 0.5vw);
			line-height: calc(1.5em + 1.5vw);
			color: #333333;
			font-weight: 600;
			margin-left: 8px;
		}

		.desc {
			text-align: start;
			font-size: calc(0.5em + 0.5vw);
			line-height: calc(1.5em + 1.5vw);
			color: #333333;
		}

		.title-text {
			font-size: calc(0.8em + 0.8vw);
			line-height: calc(1em + 1vw);
			font-weight: bold;
			color: #333333;
			margin-left: 8px;
		}

		.text {
			text-align: start;
			font-size: calc(0.5em + 0.5vw);
			line-height: calc(0.8em + 0.8vw);
			color: #333333;
			margin-left: 8px;
		}
	}

	.icon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 12px;

		.image {
			max-width: 72px;
			max-height: 72px;
			margin-bottom: 8px;
		}
	}

	::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
	    color: #FF4242;
	    background-color: #FFEDED;
	    border-color: #FFDBDC;
	    box-shadow: -1px 0 0 0 #00000000;
	}
	::v-deep .el-radio-button__inner:hover {
	    color: #FF4242;
	}
	::v-deep .el-button--danger {
	    color: #FFF;
	    background: linear-gradient(312deg, #FF2020 0%, #FF4356 100%);
	}
</style>
